import { cn } from '@/lib/utils';

interface StackedCellValueProps {
  primary?: string | number | null;
  secondary?: string | number | null;
  primaryAlign?: 'left' | 'right';
  secondaryAlign?: 'left' | 'right';
}

const getAlignClassName = (align: 'left' | 'right') => (align === 'right' ? 'text-right' : 'text-left');

export function StackedCellValue({
  primary,
  secondary,
  primaryAlign = 'left',
  secondaryAlign = 'right'
}: StackedCellValueProps) {
  return (
    <div className='flex w-full min-w-0 flex-col gap-0.5'>
      <p
        className={cn('truncate whitespace-nowrap font-semibold leading-4 text-black', getAlignClassName(primaryAlign))}
        title={String(primary ?? '')}
      >
        {primary ?? null}
      </p>
      {secondary ? (
        <p
          className={cn(
            'truncate whitespace-nowrap text-[10px] font-semibold leading-[14px] text-green-600',
            getAlignClassName(secondaryAlign)
          )}
          title={String(secondary)}
        >
          {secondary}
        </p>
      ) : null}
    </div>
  );
}
